export enum BeneficiaryGroup {
  FAMILY = 'FAMILY',
  FAMILY_CLAN = 'CLAN',
  CIRCLE = 'CIRCLE',
}
